const layout = {
  sideBar: {
    menu: {
      more: {
        children: {
          suppliers: 'Fleets',
        },
      },
    },
  },
};

export default layout;